import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/attendance",
    component: MainLayout,
    name: "attendance",
    redirect: "/attendance/reportList",
    meta: {
      title: "考勤管理",
      icon: "sliders",
    },
    // hidden: true,
    children: [
      // {
      //   path: "/attendance/reportList",
      //   name: "reportList",
      //   component: () => import("@/views/Attendance/Report"),
      //   meta: {
      //     title: "考勤报表",
      //   },
      // },
      {
        path: "/attendance/records",
        name: "records",
        component: () => import("@/views/Attendance/Records"),
        meta: {
          title: "原始记录",
        },
      },
      // {
      //   path: "/attendance/dailyAttendance",
      //   name: "dailyAttendance",
      //   component: () => import("@/views/Attendance/DailyAttendance"),
      //   meta: {
      //     title: "打卡记录",
      //   },
      // },
    ],
  },
];
